import Modal from "@/components/modal";
import PaymentMethodsForms from "./payment-methods-forms";
import {PaymentCategory} from "@/features/applications/repositories/licences-repository.ts";


interface LicencePaymentModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    baseFee: number;
    managementFee: number;
    inspectionFee?: string;
    totalFees: number;
}

export default function LicencePaymentModal({isOpen, onClose, onSubmit, baseFee, managementFee, inspectionFee, totalFees}: LicencePaymentModalProps) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <PaymentMethodsForms
                paymentCategory={PaymentCategory.LICENCE}
                header="Licence Payment"
                baseFee={baseFee?.toString()}
                managementFee={managementFee?.toString()}
                inspectionFee={inspectionFee}
                totalFees={totalFees?.toString()}
                onSubmit={onSubmit}            />
        </Modal>
    )
}